{
  "close": "關閉",
  "notifications": "通知"
}
